export default __webpack_public_path__ + "static/1989-c687ebb572b29fb87d14aa70686dc32f.gif";